import React, { useState } from 'react';
import TanStackTable from '../component/mainpage/TanStackTable'
import AddModal from '../../'


const Transaction = () => {
  


  return (
    <div>
      <TanStackTable/>
    </div>
  )
}

export default Transaction;